// Libs
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
// Components
import { EyeIcon } from 'components';
// Contex
import { ModalBuilderContext } from 'core/context';
//Config
import { ModalBuilderConfig } from 'core/ModalBuilder';
// Actions
import { reloadDatasource } from 'core/actions';

const DataResumen = ({ paycutIds, isInvoice }) => {
	const { setModal } = useContext(ModalBuilderContext);
	const modalKeys = ModalBuilderConfig.getAuthorizedModalKeys();
	const dispatch = useDispatch();

	const refreshMainData = () => dispatch(reloadDatasource());

	const handdlePaycutModal = () => {
		setModal(modalKeys.resumePaycutModal, {
			paycutIds,
			isInvoice,
			refreshMainData,
		});
	};

	return <EyeIcon button onClick={handdlePaycutModal} />;
};

export default DataResumen;
